import styled from "@emotion/styled"
import { sizer, getColorFromProps } from "@ninjaone/utils"

export const StyledGrid = styled.div`
  min-width: 1024px;
  max-width: 1680px;
  flex: 1;
  display: grid;
  margin: 0 auto;
  height: 100%;
  padding: ${sizer(0, 4)};
  grid-column-gap: ${sizer(4)};
  grid-template-columns: repeat(12, 1fr);
  grid-row-gap: ${sizer(10)};
  grid-template-rows: ${sizer(13, "minmax(0, 1fr)")};
`

export const StyledHr = styled.hr`
  height: 1px;
  width: 100%;
  border: none;
  background-color: ${getColorFromProps({ defaultTo: "gray" })};
  margin: ${({ margin }) => margin ?? 0};
`

export const StyledButtonLink = styled.button`
  cursor: pointer;
  user-select: none;
  outline: none;
  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.color.action};
  width: ${({ width = "auto" }) => width};
  text-align: ${({ textAlign = "left" }) => textAlign};
`

export * from "./Editor"
export * from "./Table"
export * from "./Input"
